import { MultiContextPieChart } from "../../pie-chart/MultiContextPieChart";
import { Box, HStack, Stack } from "@chakra-ui/react";
import { ColorBySelector } from "../../ColorByLegend/ColorBySelector";
import { ColorByLegend } from "../../ColorByLegend/ColorByLegend";
import { ColorBy } from "../../../../../map/models/ColorBy";
import { ProjectPermissions } from "../../../../../project/models/Project";

export const PieChartColorBy: React.FC<{
  value: ColorBy;
  onChange: (value: ColorBy) => void;
  projectPermissions?: ProjectPermissions;
}> = ({ value, onChange, projectPermissions }) => {
  return (
    <Stack w="100%">
      {projectPermissions?.canManageResults && (
        <HStack justifyContent="center" pt={4} px={4}>
          <ColorBySelector value={value} onChange={onChange} />
        </HStack>
      )}
      <HStack justifyContent="center" gap={0}>
        <MultiContextPieChart colorBy={value} />
        <Box py={2} pr={4} maxW="200px" minWidth="160px" flexShrink={0}>
          <ColorByLegend colorBy={value} />
        </Box>
      </HStack>
    </Stack>
  );
};
